<template>
  <div class="w-full h-full relative flex justify-center items-center">
    <div v-if="isLoading" class="font-light text-gray-500">
      Loading...
    </div>

    <div v-else-if="items.length" class="absolute inset-0 overflow-auto">
      <assets-table :items="items" @click="onClick" @info="emit('info', $event)" />
    </div>

    <div v-else class="font-light text-gray-500">
      (empty)
    </div>

    <overlay-panel :is-open="!!info" :title="title" @close="emit('dissmissInfo')" @expand="onExpand">
      <!-- <JSONView :data="info" class="text-xs" no-border /> -->
      <asset-view-short :asset="asset" />
      <template #expanded>
        <asset-view-full :asset-id="title" :asset="asset" />
      </template>
    </overlay-panel>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
// import { $get } from '../composables/useApi';
// import { JSONView } from "vue-json-component-vue-3";
// import { streamId, objectId } from '../speckleConstants';
import AssetsTable from './AssetsTable.vue';
import AssetViewShort from './AssetViewShort.vue';
import AssetViewFull from './AssetViewFull.vue';
import OverlayPanel from './OverlayPanel.vue';
import { getAssetsByLevelId, getAssetsByRoomId } from '../composables/useViewer';

defineExpose({ loadByLevel, loadByRoom, clear });

const props = defineProps({
  info: {
    type: Object,
    default: null
  }
});

const emit = defineEmits([ 'click', 'info', 'dissmissInfo' ]);

const items = ref([]);
const isLoading = ref(false);

// async function loadObject(roomId) {

//   isLoading.value = true;

//   const response = await $get(`/object/${streamId}/${objectId}/room/${roomId}/`);

//   if (response?.error) {
//     console.error('Error getting items');
//     return;
//   }

//   items.value = response.assets;
//   isLoading.value = false;
// }

const title = computed(() => {
  const id = findParameterValue(props.info, 'IFC_GUID') || props.info?.id || null;

  return id ? `${id}` : 'unknown';
});

const asset = computed(() => {
  console.log('props.info', props.info);
  return {
    name: props.info?.name,
    type: props.info?.type,
    family: props.info?.family,
    category: props.info?.category,
    level: props.info?.level,
    model: findParameterValue(props.info, 'ALL_MODEL_TYPE_NAME') || props.info?.name,
    manufacturer: findParameterValue(props.info, 'ALL_MODEL_MANUFACTURER'),
    familyName: findParameterValue(props.info, 'SYMBOL_FAMILY_NAME_PARAM') || findParameterValue(props.info, 'ELEM_FAMILY_PARAM'),
    description: findParameterValue(props.info, 'ALL_MODEL_DESCRIPTION')
  };
});

function findParameterValue(info, parameterName) {
  const parameters = info?.properties?.Parameters;
  if (!parameters) {
    return null;
  }

  for (const group of Object.values(parameters)) {
    for (const parameter of Object.values(group || {})) {
      if (parameter?.internalDefinitionName === parameterName || parameter?.name === parameterName) {
        return parameter.value;
      }
    }
  }

  return null;
}

function loadByLevel(levelId) {
  items.value = getAssetsByLevelId(levelId);
}

function loadByRoom(roomId) {
  items.value = getAssetsByRoomId(roomId);
}

function clear() {
  items.value = [];
}

function onClick(item) {
  emit('click', item.id);
}

function onExpand() {
  console.log('onExpand');
  // emit('info', props.info);
}
</script>
